import { fetchDataRequest } from 'services/ApiService';
import { ORGID_PATH_PARAM, INITIATIVEID_PATH_PARAM } from 'constants/api';
import { formatBalance } from 'services/NumberFormatters';
import { formatDateDefault } from 'services/DateFormatters';

export const getInitiativeDisplayData = async (initiativeId, orgid) => {
    const fetchedInitiative = await fetchDataRequest('initiativeDisplayData', [ORGID_PATH_PARAM, INITIATIVEID_PATH_PARAM], [orgid, initiativeId]) || [];
    return {
        id: fetchedInitiative?.id ? fetchedInitiative?.id : 0,
        name: fetchedInitiative?.name ? fetchedInitiative?.name : 'No name specified',
        description: fetchedInitiative?.description ? fetchedInitiative?.description : 'No description specified',
        status: fetchedInitiative?.status ? fetchedInitiative?.status : 'No status specified',
        project: fetchedInitiative?.projectName ? fetchedInitiative?.projectName : 'No project specified',
        budget: fetchedInitiative?.budget ? formatBalance(fetchedInitiative?.budget) : formatBalance(0),
        startDate: fetchedInitiative?.startDate ? formatDateDefault(fetchedInitiative?.startDate) : 'No start date specified',
        endDate: fetchedInitiative?.endDate ? formatDateDefault(fetchedInitiative?.endDate) : 'No end date specified',
        productCount: Array.isArray(fetchedInitiative?.products) ? fetchedInitiative?.products.length : 0, 
    };
};

// temp solution to mock drill down data after component generation - data may not exist
// makes it easy to clean up mock data and use real data when available (just search for this functions usage)
export const getMockDrillDownData = () => {
    return [{ id: '2578cb65923bb7ba0845014820190617', name: 'fake product number 1', description: 'description number 1' }, { id: '9876cb65923bb7ba0845014820190617', name: 'fake product number 2', description: 'description number 2' }];
};





// WEBPACK FOOTER //
// ./services/initiativeService.js